import { getStatusConfigByLabel, StatusConfig } from 'src/utils/statusUtils';
import FontAwesomeIcon from 'src/components/Icon';
import IcoMoon from 'src/components/IcoMoon';
import Tooltip from 'src/components/Tooltip/Tooltip';
import './StatusIcon.scss';

const CANCELLED_TOOLTIP: string =
  "This event was most likely cancelled by the event owner on Cal.com. If you're the event owner, check your Cal.com account; otherwise contact the event owner shown on this event.";

interface StatusIconProps {
  status: string;
  showLabel?: boolean;
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

const StatusIcon = ({
  status,
  showLabel = true,
  size = 'medium',
  className = '',
}: StatusIconProps) => {
  const isCancelled: boolean = status?.toLowerCase() === 'CANCELLED';

  if (isCancelled) {
    return (
      <Tooltip content={CANCELLED_TOOLTIP}>
        <div
          className={`status-icon status-icon--${size} status-icon--cancelled ${className}`}
        >
          <div className="status-icon__icon">
            <FontAwesomeIcon
              glyph="calendar-times"
              weight="solid"
              size="solid"
            />
          </div>
          {showLabel && (
            <span className="status-icon__label">Cancelled</span>
          )}
        </div>
      </Tooltip>
    );
  }

  const statusConfig: StatusConfig = getStatusConfigByLabel(status);

  const renderIcon = () => {
    // Handle special FontAwesome cases (same logic as original StatusOverviewCard).
    if (statusConfig.label === 'Under Review') {
      return (
        <FontAwesomeIcon glyph="hourglass-end" weight="light" size="solid" />
      );
    }

    if (statusConfig.label === 'One Year Warranty') {
      return (
        <FontAwesomeIcon glyph="certificate" weight="solid" size="solid" />
      );
    }

    return <IcoMoon glyph={statusConfig.glyph} />;
  };

  return (
    <div className={`status-icon status-icon--${size} ${className}`}>
      <div className="status-icon__icon">{renderIcon()}</div>
      {showLabel && (
        <span className="status-icon__label">{statusConfig.label}</span>
      )}
    </div>
  );
};

export default StatusIcon;
